// extracted by mini-css-extract-plugin
var _1 = "HistorySidebar-module__active--G5w0q";
var _2 = "HistorySidebar-module__animatedBackground--Ew9gx";
var _3 = "HistorySidebar-module__closeButtonContainer--g3Eh2";
var _4 = "HistorySidebar-module__content--rhChS";
var _5 = "HistorySidebar-module__tab--cPQn0";
var _6 = "HistorySidebar-module__tabs--RItHC";
export { _1 as "active", _2 as "animatedBackground", _3 as "closeButtonContainer", _4 as "content", _5 as "tab", _6 as "tabs" }
